module.exports = __webpack_public_path__ + "img/2-4.087fa857.png";